import { getSelectedPerson } from 'store/selectedBubble/reducer';
import { useSelector } from 'react-redux';
import { FC } from 'react';
import { SpriteList } from 'domain/bubble';
import { PersonSprite } from './PersonSprite';

interface PersonsProps {
  personsSpritesList: SpriteList;
}

export const PersonComponent: FC<PersonsProps> = ({ personsSpritesList }) => {
  const currentPersons = useSelector(getSelectedPerson);
  return Object.keys(personsSpritesList).length > 0 ? (
    <>
      {currentPersons.map(
        (person) =>
          person.personId && (
            <PersonSprite
              key={`${person.personId}_${person.skinId}_${person.position}`}
              currentPerson={person}
              personsSpritesList={personsSpritesList}
            />
          )
      )}
    </>
  ) : null;
};
